<h1 mat-dialog-title>Excluir cliente</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 700px;">
    <div class="row mt-4" *ngIf="!bAutenticado">
        <div class="col-sm">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Senha master</mat-label>
                <input type="password" id="input_senha_master" matInput [(ngModel)]="senhaMaster" maxlength="50"
                    (keypress)="($event.charCode==13)?autenticarSenha():null" required>
            </mat-form-field>
        </div>

        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>close</mat-icon> Cancelar
            </button>
        </div>
        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="primary" (click)="autenticarSenha()">
                <mat-icon>check</mat-icon> Autenticar
            </button>
        </div>
    </div>

    <div *ngIf="bAutenticado">

        <div class="row mt-4 mb-4">
            <div class="col-sm">
                * Ao excluir o cliente, ele perderá seu acesso e os dados serão <strong>removidos
                    permanentemente</strong> do banco de dados. Caso o cliente possua alguma venda realizada, estes
                serão mantidos. <strong>Não será possível vincular as compras antigas com um novo cadastro.</strong>
            </div>
        </div>

        <mat-divider></mat-divider>

        <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
            <button mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>clear</mat-icon> Cancelar
            </button>
            <button mat-flat-button color="primary" (click)="confirmarExclusaoCliente()">
                <mat-icon>check</mat-icon> Confirmar exclusão do cliente
            </button>
        </section>
    </div>
</div>